<template>
  <section>
    <CreditsHeader />
    <CreditsIntro />
    <CreditsIndex />
  </section>
</template>

<script>
import * as partials from './partials'

export default {
  name: 'Credits',
  components: { ...partials },
  provide() {
    return {
      wp: this.$wp.pages.credits || {}
    }
  },
  mounted() {
    console.log('credit', this.$wp.pages.credits)
  }
}
</script>
